import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule } from '@angular/forms';
import * as moment from 'moment';
import { CalendarModule } from 'primeng/calendar';
import { debounceTime, distinctUntilChanged, filter, Subject } from 'rxjs';
import { RoleManagementService } from 'src/app/module/ems-master/component/role-managements/role-management.service';
import { EmsServicesService } from 'src/app/module/ems-master/services/ems-services.service';
import { SharedService } from 'src/app/shared/shared.service';
import { TabService } from 'src/app/shared/tab.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent {
  @Input() showDateRange: boolean = false;
  @Input() warehouseList: any[] = [];
  @Input() accounts: any[] = [];
  @Input() showCustomer: boolean = false;

  @Input() orderNumber : boolean = false
  @Input() orderStatus : boolean = false
  @Input() DateofPlacement : boolean = false
  @Input() showDate: boolean = false;
  @Input() showWarehouse: boolean = false;
  @Input() showCustomerAndWarehouse: boolean = false;
  @Input() showStatus?: boolean;
  @Input() showZone: boolean = false;
  @Input() showCity: boolean = false;
  @Input() showRegion: boolean = false;
  @Input() showExpenseType: boolean = false;
  @Input() showFY: boolean = false;
  @Input() showMonth: boolean = false;
  @Input() showBillingType: boolean = false;
  @Input() showUnitsOfMeasurement: boolean = false;
  @Input() showExpensesHead: boolean = false;
  @Input() showInvoiceStatus: boolean = false;
  @Input() showVendor: boolean = false;
  @Input() showVendorCode: boolean = false;
  @Input() showCategory: boolean = false;
  @Input() showExpenseMode: boolean = false;
  @Input() showUserName: boolean = false;
  @Input() showUserEmail: boolean = false;
  @Input() showUserMobileNo: boolean = false;
  @Input() showBudgetType: boolean = false;
  @Input() showDesignation: boolean = false;
  @Input() showOwnershipType: boolean = false;
  @Input() showWarehouseType: boolean = false;
  @Input() showDepartment: boolean = false;
  @Input() showExpenseCategory: boolean = false;
  @Input() showRoleName: boolean = false;
  @Input() showEmployeeName: boolean = false;
  @Input() showCustShortName: boolean = false;
  @Input() showInvoiceNo: boolean = false;
  @Input() showQuickCodeName: boolean = false;
  @Input() showCurrentApproval:boolean = false;
  @Input() showUserAgeing:boolean = false;
  @Input() showDateFilter: boolean = false;
  @Input() showInvoiceId: boolean = false;
  @Input() showStateName : boolean = false
  @Input() showCityName: boolean = false
  @Input() showCityCode: boolean = false
  @Input() routeCode: boolean = false
  @Input() sourceCity: boolean = false
  @Input() destinationCity: boolean = false
  @Input() ShowVehicleType : boolean = false
  @Input() ShowCapacity : boolean = false
  @Input() ShowTonnage : boolean = false

  
  // Output events to notify parent component
  @Output() filterChange = new EventEmitter<any>();
  @Output() resetFilters = new EventEmitter<void>();

  searchForm: FormGroup;
  searchDropDownToggle: boolean = false

  category: any;
  clientId: any;
  customerModel: any;
  warehouseFilter: any = [];
  selectedCategories: any[] = []
  tabFilter: any
  allCatagory:any;
  sendCatagoryId:any;
  zoneList:any;
  regionList:any;
  cityList:any;
  expenseTypeList:any;
  financialYearList:any;
  date: Date[] | undefined;
  wareHouseList:any;
  accountMappingList:any;
  budgetType:any;
  designation:any;
  accountLists: any;
  ownershipType:any;
  whType: any;
  department: any;
  expenseCategory: any;
  roleList: any;
  expenseMode: any;
  vendorsList: any;
  EmployeesList: any;
  searchFilterList: any;
  selectedMappingIds: any;
  rangeDates: Date[] | undefined;
  searchExpenseFilterList: any;
  selectedOption :any = "";
  showCustomDateRange: boolean = false;
  dateRangePayload: any[] = [];
  postData: any;
  filters: any;
  today: Date = new Date(); 
  statusList: any;
  locationLists: any;
  constructor(private tabService: TabService,private emsServices: EmsServicesService,private sharedService: SharedService,
    private roleManagementService: RoleManagementService) {
    this.searchForm = new FormGroup({
      ACCOUNT_ID_IN: new FormControl(''),
      MAPPING_IN: new FormControl(''),
      WAREHOUSE_ID_IN: new FormControl(''),
      STATUS_IN: new FormControl(),
      ZONE_IN: new FormControl(''),
      REGION_IN: new FormControl(''),
      CITY: new FormControl(''),
      EXPENSE_IN: new FormControl(''),
      YEAR_IN: new FormControl(''),
      DUMMY_FILTER_TWO: new FormControl(''), // DUMMY_FILTER_TWO IS USED FOR MONTH
      DUMMY_FILTER_THREE: new FormControl(''), // DUMMY_FILTER_THREE IS USED FOR Custom Range
      FROM_DATE: new FormControl(''),
      TO_DATE: new FormControl(''),
      CREATED_FROM_DATE: new FormControl(''),
      CREATED_TO_DATE: new FormControl(''),
      BILLINGTYPE: new FormControl(''),
      UNITOFMEASUREMENT: new FormControl(''),
      EXPENSESHEAD: new FormControl(''),
      INVOICESTATUS: new FormControl(''),
      VENDOR: new FormControl(''),
      CATEGORY_IN: new FormControl([]),
      CUSTOMER: new FormControl(''),
      // DUMMY_FILTER_ONE: new FormControl(),  // DUMMY_FILTER_ONE IS USED FOR CUSTOMER-WAREHOUSE 
      EXPENSE_MODE_IN: new FormControl(''),
      USER_NAME_IN: new FormControl(''),
      VENDOR_NAME_IN: new FormControl(''),
      VENDOR_CODE: new FormControl(''),
      EMAIL_IN: new FormControl(''),
      MOBILE_NUMBER: new FormControl(''),
      BUDGET_TYPE: new FormControl(''),
      DESIGNATION_IN: new FormControl(''),
      OWNERSHIP_TYPE_IN: new FormControl(''),
      WAREHOUSE_TYPE: new FormControl(''),
      DEPARTMENT_IN: new FormControl(''),
      USER_ROLE: new FormControl(''),
      USER_ID_IN: new FormControl(''),
      USER_NAME: new FormControl(''),
      ACCOUNT_CODE_IN: new FormControl(''),
      INVOICE_NUMBER: new FormControl(''),
      VENDOR_INVOICE_IN: new FormControl(''),
      INVOICE_NUMBER_LIKE: new FormControl(''),
      VENDOR_ID_IN: new FormControl(''),
      ORDER_NUMBER_IN: new FormControl(''),
      NAME_IN: new FormControl(),
      CATEGORY: new FormControl(),
      DUMMY_FILTER_ONE: new FormControl(),  // DUMMY_FILTER_ONE IS USED FOR DATE FILTER 
      DATE_RANGE: new FormControl([]) ,
      INVOICE_IN: new FormControl(),
      CITY_NAME: new FormControl(),
      STATE_IN: new FormControl(),
      CITY_CODE: new FormControl(),
      ROUTE_CODE_IN: new FormControl(),
      SOURCE_CITY_IN: new FormControl(),
      DESTINATION_CITY_IN: new FormControl(),
      VEHICLE_TYPE_IN: new FormControl(),
      VEHICLE_TONNAGE_IN: new FormControl(),
      CAPACITY_IN: new FormControl(),
    });
    this.allCatagory = JSON.parse(localStorage.getItem('categoryMap')!)
    this.accountMappingList = JSON.parse(localStorage.getItem('accountMappingList')!);
    this.wareHouseList = JSON.parse(localStorage.getItem('wareHouseList')!);
    this.accountLists = JSON.parse(localStorage.getItem('accountList')!);
    this.sendCatagoryId = this.setId()
    console.log(this.sendCatagoryId,'this.sendCatagoryId')
    this.getQuickCodeListByCategoryId(this.sendCatagoryId.toString())
  }

  ngOnInit(): void {
    if(this.showExpenseType){
      this.getExpenseList()
    }
    if(this.showWarehouse){
      // this.getWarehouseList()
    }
    if(this.showRoleName){
      // this.getroleList()
    }
    if(this.showCustomer){
      this.getaccountsList();
    }
    if(this.showCurrentApproval || this.showUserAgeing){
      this.getEmployeesList()
    }
    if(this.showInvoiceNo || this.showVendor || this.showInvoiceId  ){
      this.getVendors()
    }
    if(this.orderStatus){
      this.getStatus()
    }
    if(this.routeCode){
      this.getLocations()
    }
    const categoryData = JSON.parse(localStorage.getItem('category')!);
    if (categoryData?.length>0) {
      this.category = categoryData;
    }

    // Tab service
    const activeTabIndex = this.tabService.activeTab;
    const activeTab = this.tabService.tabs[activeTabIndex];
    if (activeTab?.filterData) {
      this.warehouseFilter = activeTab.filterData;
      
      this.tabFilter = this.tabService.transformFiltersArrayToObject(activeTab.filterData);
      this.searchForm.patchValue(activeTab.filterData);
      const categoryFilter = this.tabFilter

      const textInputKeys = [
        'ACCOUNT_CODE_IN',
        'USER_NAME_IN',
        'EMAIL_IN',
        'MOBILE_NUMBER',
        'BUDGET_TYPE',
        'USER_NAME',
        'INVOICE_NUMBER',
        'VENDOR_INVOICE_IN',
        'INVOICE_NUMBER_LIKE',
        'VENDOR_ID_IN',
        'NAME_IN',
        'INVOICE_IN',
        'VENDOR_NAME_IN',
        'VENDOR_CODE',
        'ORDER_NUMBER_IN',
        'CITY_NAME',
        'STATE_IN',
        'CITY_CODE',
        'ROUTE_CODE_IN',
        'SOURCE_CITY_IN',
        'DESTINATION_CITY_IN',
        'VEHICLE_TYPE_IN',
        'VEHICLE_TONNAGE_IN',
        'CAPACITY_IN',
        
      ];
      // coeyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI2NiIsImlhdCI6MTczMTM5MDQwMywiZXhwIjoxNzMyMjU0NDAzfQ.H8pdXopc_uKec7iLuSk192moOjTHx-0OWFkevGnL_h0hPbBtD8_OPekQqsMnUrKutrtllrM9cn1wGrnw4jgO9wnst categoryValues = categoryFilter['CATEGORY_IN'] ? categoryFilter['CATEGORY_IN'].split(',').map((val: any) => Number(val)) : [];
      // this.searchForm.get('CATEGORY_IN')?.setValue(categoryValues);
      // this.searchForm.get('STATUS')?.setValue(Number(categoryFilter['STATUS']));

      Object.entries(categoryFilter).forEach(([key, value]) => {
        if (value) {
          if (typeof value === 'string') {
            this.searchForm.get(key)?.setValue(value.split(',').map(val => Number(val)));
            this.searchForm.get('STATUS_IN')?.setValue(Number(categoryFilter['STATUS_IN']));
            // const parsedValue = value.includes(',')
            //   ? value.split(',').map(val => Number(val)) : Number(value); 
            // this.searchForm.get(key)?.setValue(parsedValue);
            // console.log(value)
            if (textInputKeys.includes(key)) {
              this.searchForm.get(key)?.setValue(value);
            }
          } 
          else {
            this.searchForm.get(key)?.setValue(value);
          }
        }
        if(key === 'DUMMY_FILTER_THREE'){
          if(value){
            this.selectedOption = value
            if(this.selectedOption === 'custom'){
              this.showCustomDateRange = true
              if(this.searchForm.controls['CREATED_FROM_DATE'].value){
                const formattedDate = this.sharedService.convertToISOFormat(this.searchForm.controls['CREATED_FROM_DATE'].value);
                this.searchForm.controls['CREATED_FROM_DATE'].setValue(formattedDate)
              }
              if(this.searchForm.controls['CREATED_TO_DATE'].value){
                const formattedDate = this.sharedService.convertToISOFormat(this.searchForm.controls['CREATED_TO_DATE'].value);
                this.searchForm.controls['CREATED_TO_DATE'].setValue(formattedDate)
              }
            }
            else{
              if(this.searchForm.controls['CREATED_FROM_DATE'].value){
                const formattedDate = this.sharedService.convertToDateFormat(this.searchForm.controls['CREATED_FROM_DATE'].value);
                this.searchForm.controls['CREATED_FROM_DATE'].setValue(formattedDate)
              }
              if(this.searchForm.controls['CREATED_TO_DATE'].value){
                const formattedDate = this.sharedService.convertToDateFormat(this.searchForm.controls['CREATED_TO_DATE'].value);
                this.searchForm.controls['CREATED_TO_DATE'].setValue(formattedDate)
              }
            }
          }
        }
        if(key === 'MAPPING_IN'){
          const data = Number(value)
          this.searchForm.controls['MAPPING_IN'].setValue(data)
        }
        if(key === 'DUMMY_FILTER_TWO'){
          if (value) {
            const date = new Date(value as string | number);
            if (!isNaN(date.getTime())) {
              this.searchForm.controls['DUMMY_FILTER_TWO'].setValue(date);
            }
          }
        }
      });
      console.log(this.searchForm)
      this.filterChange.emit(activeTab.filterData);
    }
    else{
      this.filterChange.emit([]);
    }
    this.clientId = localStorage.getItem('clientId') ? localStorage.getItem('clientId') : ''

    // call API when verdor type 
      this.vendorInput$.pipe(
          debounceTime(300),
          distinctUntilChanged()
        ).subscribe(searchText => {
          this.onSearchVendor(searchText);
        });

         // call API when verdor type 
      this.EmpInput$.pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(searchText => {
        this.onSearchEmp(searchText);
      });
  }

  onSubmit() {
  const range = this.searchForm.value.DATE_RANGE;

    console.log(range)
    // this.searchForm.removeControl('WAREHOUSEMAPPING')
    // this.searchForm.controls['MONTH'].setValue('')
    const formattedFilters = Object.entries(this.searchForm.value).reduce<any[]>((acc, [key, value]) => {
      if (value || value === 0) {
        if (key === 'FROM_DATE' || key === 'TO_DATE' || key === 'CREATED_FROM_DATE' || key === 'CREATED_TO_DATE' || key === 'DATE_RANGE') {
          acc.push({
            key: key,
            // dateTimeValue: value
            dateTimeValue: moment(value).format('DD-MM-YYYY HH:mm:ss Z').replace(/(\+\d{2}):(\d{2})/, '$1$2')
          });
        } else {
          const filterValue = Array.isArray(value) ? value.join(',') : String(value);
          acc.push({
            key: key,
            value: filterValue
          });
    
          // Add extra field if key is USER_ID_IN
          if (key === 'USER_ID_IN' && this.showCurrentApproval) {
            acc.push({
              key: 'APPROVAL_STATUS',
              value: '1'
            });
          }
        }
      }
      
     
      return acc;
    }, []);
     if (this.rangeDates && this.rangeDates.length === 2) {
      const [startDate, endDate] = this.rangeDates;
      const formatToUTC = (date: Date): string => {
            const dd = String(date.getUTCDate()).padStart(2, '0');
            const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
            const yyyy = date.getUTCFullYear();
            return `${dd}-${mm}-${yyyy} +0000`;
          };
       if (startDate && endDate) {
          formattedFilters.push(
            {
              key: 'FROM_DATE',
              dateValue: formatToUTC(startDate)
            },
            {
              key: 'TO_DATE',
              dateValue: formatToUTC(endDate)
            }
          );
        }

        
      }

      if (this.dateRangePayload?.length) {
        formattedFilters.push(...this.dateRangePayload);
      }
    const filteredData = formattedFilters.filter(item => item.value !== "");
    const updatedFilters = filteredData.filter(item => item.key !== "DUMMY_FILTER_TWO" && item.key !== "DATE_RANGE");

    this.filterChange.emit(updatedFilters);
    const activeTabIndex = this.tabService?.activeTab;
    this.tabService.updateFilterData(activeTabIndex, updatedFilters);
    this.searchDropDownToggle = !this.searchDropDownToggle;
  }

  setMonth(event:any){
    const { startDate, endDate } = this.sharedService.getStartAndEndDates(event);
    const sendStartDate = this.sharedService.parseDateStringToDate(startDate)
    const sendEndDate = this.sharedService.parseDateStringToDate(endDate)
    this.searchForm.controls['FROM_DATE'].setValue(sendStartDate)
    this.searchForm.controls['TO_DATE'].setValue(sendEndDate)
  }

  onReset() {
    // this.searchForm.addControl('WAREHOUSEMAPPING', new FormControl(''));
    this.showCustomDateRange = false
    this.selectedOption = "";
    this.searchForm.reset();
    this.resetFilters.emit();
    const activeTabIndex = this.tabService?.activeTab;
    this.tabService.updateFilterData(activeTabIndex, []);
    this.searchDropDownToggle = !this.searchDropDownToggle;
    this.searchFilterList = []
    this.rangeDates = []
  }

  setId(){
    const obj  = []
    if(this.showZone){
      obj.push(this.allCatagory.zone.id)
    }
    if(this.showFY){
      obj.push(this.allCatagory.financialYear.id)
    }
    if(this.showRegion){
      obj.push(this.allCatagory.region.id)
    }
    if(this.showCity){
      obj.push(this.allCatagory.city.id)
    }
    return obj
  }
  getQuickCodeListByCategoryId(ids:any) {
    this.emsServices
      .getQuickCodeListByCategoryId(ids)
      .subscribe((data: any) => {
        this.zoneList = data?.responseObject?.zone
        this.financialYearList = data?.responseObject?.financialYear
        this.regionList = data?.responseObject?.region
        this.cityList = data?.responseObject?.city
        this.budgetType = data?.responseObject?.budgetType
        this.designation = data?.responseObject?.designation
        this.ownershipType = data?.responseObject?.ownershipType
        this.whType = data?.responseObject?.warehouseType
        this.department = data?.responseObject?.department
        this.expenseCategory = data?.responseObject?.expenseCategory
        this.expenseMode = data?.responseObject?.expenseMode
      });
  }

  getExpenseList(){
    this.emsServices
    .getExpenseList([], 0, 50000,'id','DESC')
    .subscribe((data: any) => {
      this.expenseTypeList = data?.responseObject?.content;
    },err => {
      this.expenseTypeList = []
    });
  }

  getaccountsList(){
    this.emsServices
      .getAccounts([], 0, 500, 'id', 'ASC')
      .subscribe((data: any) => {
        this.accountLists = data?.responseObject?.content;
      }, err => {
        // console.log(err);
        this.accountLists = []
      });
  }
  
  getWarehouseList(){
    const data = JSON.parse(localStorage.getItem('accountList')!)
      const transformedData  = data;

          
    // Transforming the data
    this.wareHouseList = transformedData.flatMap((item:any) =>
      item.accountWarehouseInfo.map((warehouse:any) => ({
        id: item.id,
        accountName: item.accountName,
        accountCode: item.accountCode,
        accountDescription: item.accountDescription,
        status: item.status,
        warehouseId: warehouse.warehouseId,
        warehouseName: warehouse.warehouseName,
        expenseAssociated: warehouse.expenseAssociated,
      }))
    );

    if(this.searchForm.controls['ACCOUNT_ID_IN'].value){
      this.wareHouseList.forEach((el:any)=>{
        if(el.id == this.searchForm.controls['ACCOUNT_ID_IN'].value && el.warehouseId == this.searchForm.controls['WAREHOUSE_ID_IN'].value){
          this.searchForm.controls['DUMMY_FILTER_ONE'].setValue(el)
        }
      })
    }
  }

  selectWarehouse(event:any){
    console.log(this.searchForm.value.DUMMY_FILTER_ONE)
    const WAREHOUSEMAPPING =
      this.searchForm.value.DUMMY_FILTER_ONE;
    const transformedMapping = Array.isArray(WAREHOUSEMAPPING)
      ? WAREHOUSEMAPPING.map((wh: any) => ({ 
        clientId: wh?.id,
        "warehouseId": wh?.warehouseId
      })) 
      : [];
    const clientIds = transformedMapping.map(item => item.clientId);
    const clientIdString = clientIds.join(',');
    this.searchForm.controls['ACCOUNT_ID_IN'].setValue(clientIdString);
    const warehouseIds = transformedMapping.map(item => item.warehouseId);
    const warehouseIdString = warehouseIds.join(',');
    this.searchForm.controls['WAREHOUSE_ID_IN'].setValue(warehouseIdString);
    console.log(this.searchForm)
  }

  getroleList() {
    const obj = [
      {
        "key": "PLATFORM",
        "value": "ems"
      }
     ];
    this.roleManagementService.getRolelist(obj,0,500).subscribe(
      (res:any) => {
        this.roleList = res?.responseObject.content
      }
    );
  }
  getVendors() {
     this.postData = [
      // {    
      //   "key": "USER_TYPE",
      //   "value": "2"
      // },
      // {
      //   "key":"PLATFORM_IN",
      //   "value":"ems"
      // }
    ]

    if (this.filters) {
      Object.values(this.filters).forEach((filter: any) => {
        this.postData.push(filter);
      });
    }
    this.emsServices
      .getVendorInfo(this.postData, 0, '50','id','ASC')
      .subscribe((data: any) => {
        this.vendorsList = data?.responseObject?.content;
      });
  }
  getEmployeesList() {
    const postData  = [
      {    
        "key": "USER_TYPE",
        "value": "1"
      },
      {
        "key":"PLATFORM_IN",
        "value":"ems"
      },
      {
        key: 'STATUS_IN',
        value: '1'
      },
    ]

    this.emsServices
      .getUsers(postData, 0, 20,'id','DESC')
      .subscribe((data: any) => {
        this.EmployeesList = data?.responseObject?.content;
      });
  }

  EmpInput$ = new Subject<string>();
  vendorInput$ = new Subject<string>();
  // vendorsList: any[] = [];
  // isLoading = false;
  onSearchVendor(term: string) {
    // this.isLoading = true;
  
    const postData = [
      // {
      //   key: 'USER_TYPE',
      //   value: '2'
      // },
      // {
      //   key: 'STATUS_IN',
      //   value: '1'
      // },
      // {
      //   key: 'PLATFORM_IN',
      //   value: 'ems'
      // }
    ];
  
    if (term && term.trim().length > 0) {
      postData.push({
        key: 'VENDOR_NAME_IN',
        value: term.trim()
      });
    }
  
    this.emsServices.getVendorInfo(postData, 0, 50, 'id', 'DESC').subscribe(
      (data: any) => {
        this.vendorsList = data?.responseObject?.content || [];
        // this.isLoading = false;
      },
      () => {
        this.vendorsList = [];
        // this.isLoading = false;
      }
    );
  }

  onSearchEmp(term: string) {
    // this.isLoading = true;
  
    const postData = [
      {
        key: 'USER_TYPE',
        value: '1'
      },
      {
        key: 'STATUS_IN',
        value: '1'
      },
      {
        key: 'PLATFORM_IN',
        value: 'ems'
      }
    ];
  
    if (term && term.trim().length > 0) {
      postData.push({
        key: 'NAME_IN',
        value: term.trim()
      });
    }
  
    this.emsServices.getUsers(postData, 0, 50, 'id', 'DESC').subscribe(
      (data: any) => {
        this.EmployeesList = data?.responseObject?.content || [];
        // this.isLoading = false;
      },
      () => {
        this.EmployeesList = [];
        // this.isLoading = false;
      }
    );
  }

onSearch(term: any) {
  if (!term?.term || typeof term?.term !== 'string') {
    // Reset to full list when search is cleared or invalid
    this.searchFilterList = [...this.accountMappingList];
    return;
  }
  const lower = term?.term.toLowerCase();
  this.searchFilterList = this.accountMappingList.filter((d: any) =>
    d.accountName?.toLowerCase().includes(lower) ||
    d.warehouseName?.toLowerCase().includes(lower)
  );
}
onExpenseSearch(term: any) {
  if (!term?.term || typeof term?.term !== 'string') {
    // Reset to full list when search is cleared or invalid
    this.searchExpenseFilterList = [...this.expenseTypeList];
    return;
  }
  const lower = term?.term.toLowerCase();
  this.searchExpenseFilterList = this.expenseTypeList.filter((d: any) =>
    d.expenseName?.toLowerCase().includes(lower) 
  );
}

  onSelectAll(type: string, list: any[]) {
    console.log(this.searchFilterList)
  if (this.searchFilterList && this.searchFilterList.length && type == 'MAPPING_IN') {
    const newSelectedValues  = this.searchFilterList.map((item: any) => item?.id);
    const control = this.searchForm.get(type);
    console.log(control)
    if (control) {
        const prevSelectedValues = control.value || [];
        const mergedValues = Array.from(new Set([...prevSelectedValues, ...newSelectedValues ]));
        control.setValue(mergedValues);
     
    } else {
      // console.warn(`Form control '${type}' does not exist.`);
    }
    // console.log(`Selected values for '${type}':`, selectedValues);
  } else if(type == 'MAPPING_IN' && this.searchFilterList == undefined){
    const newSelectedValues  = list.map((item: any) => item?.id);
        const control = this.searchForm.get(type);
        if (control) {
            control.setValue(newSelectedValues);
        }   
  }else {
    const newSelectedValues  = list.map((item: any) => item?.id);
    const control = this.searchForm.get(type);
    if (control) {
        // const prevSelectedValues = control.value || [];
        // const mergedValues = Array.from(new Set([...prevSelectedValues, ...newSelectedValues ]));
        control.setValue(newSelectedValues);
      
    }

    // console.log(`No items found in the provided list for '${type}'.`);
  }
}


onSelectAllExpense(type: string, list: any[]) {
  if (this.searchExpenseFilterList && this.searchExpenseFilterList.length && type == 'EXPENSE_IN') {
    const newSelectedValues  = this.searchExpenseFilterList.map((item: any) => item?.id);
    const control = this.searchForm.get(type);
    if (control) {
        const prevSelectedValues = control.value || [];
        const mergedValues = Array.from(new Set([...prevSelectedValues, ...newSelectedValues ]));
        control.setValue(mergedValues);
     
    } else {
    }
  } else if(type == 'EXPENSE_IN' && this.searchExpenseFilterList == undefined){
    const newSelectedValues  = list.map((item: any) => item?.id);
        const control = this.searchForm.get(type);
        if (control) {
            control.setValue(newSelectedValues);
        }   
  }else {
    const newSelectedValues  = list.map((item: any) => item?.id);
    const control = this.searchForm.get(type);
    if (control) {
        control.setValue(newSelectedValues);
      
    }
  }
}
  onClearAll(type: string) {
  const control = this.searchForm.get(type);
  if (control) {
    control.setValue([]);
  }
}

onOptionChange(event: any): void {
  this.selectedOption = event.target.value;
  this.showCustomDateRange = this.selectedOption === 'custom';

  if (this.selectedOption !== 'custom') {
    let dateRange = this.sharedService.getPredefinedDateRange(this.selectedOption);
    if (dateRange) {
      this.searchForm.patchValue({
        CREATED_FROM_DATE: dateRange.startDate,
        CREATED_TO_DATE: dateRange.endDate
      });
      console.log(dateRange);
    }
  }
}

selectRange(event: any) {
  const range = this.searchForm.value.DATE_RANGE;
  if (range && range[0] && range[1]) {
    const fromDate = moment(range[0]).format('DD-MM-yyyy ZZ')
    const toDate = moment(range[1]).format('DD-MM-yyyy ZZ')

    this.dateRangePayload = [
      {
        key: 'FROM_DATE',
        dateValue: fromDate
      },
      {
        key: 'TO_DATE',
        dateValue: toDate
      }
    ];
  } else {
    this.dateRangePayload = [];
  }
}


  getStatus() {
    // this.emsServices
    //   .getStatus()
    //   .subscribe((data: any) => {
    //     this.statusList = data?.responseObject;
    //   });
  }

  getLocations(){
  this.emsServices.getLocations([], 0, 1000)
    .subscribe((data: any) => {
      this.locationLists = data?.responseObject?.content;
      console.log(this.locationLists)
    });
}
  
}
